module.exports = __webpack_public_path__ + "/img/5db6cbedaefe211801846d54f4bc3870.svg";